import React, { createRef, FunctionComponent, KeyboardEventHandler, MouseEventHandler } from "react";

import { bemClassNames, createQA, TAB_INDEX_FOCUSABLE_ONLY, useSetFocus } from "@multiweb/reactUtils";
import { AccessibilityProps, QAProps } from "@multiweb/types/react";
import { activationKeyBlockHandler, activationMouseBlockHandler, createActivationKeyHandler, createActivationMouseHandler } from "../../utils";

export type LogoComponentProps = {
    /** Popis tlačítka */
    title?: string;
    /** Callback volaný při kliknutí */
    onClick?: MouseEventHandler<HTMLButtonElement>;
    /** Callback volaný při uvolnění klávesy */
    onKeyUp?: KeyboardEventHandler<HTMLButtonElement>;
    /** Příznak, zda je komponenta zaměřená. */
    isFocused: boolean;
} & QAProps &
    Pick<AccessibilityProps, "ariaLabel">;

const classNames = bemClassNames("logo");

/** Logo aplikace */
export const LogoComponent: FunctionComponent<LogoComponentProps> = ({ title, ariaLabel, onClick, onKeyUp, isFocused, qa }) => {
    const ref = createRef<HTMLButtonElement>();
    useSetFocus<HTMLButtonElement>(isFocused, ref);
    const handleClick = createActivationMouseHandler(onClick);
    const handleKeyUp = createActivationKeyHandler(onKeyUp);
    return (
        <button
            aria-label={ariaLabel}
            className={classNames()}
            tabIndex={TAB_INDEX_FOCUSABLE_ONLY}
            onClick={handleClick}
            onMouseDown={activationMouseBlockHandler}
            onKeyUp={handleKeyUp}
            onKeyDown={activationKeyBlockHandler}
            {...{ ref, title }}
            {...createQA(qa)}
        >
            <div className={classNames("icon")} />
        </button>
    );
};
